import { DefaultTheme } from "@react-navigation/native";
// import { MD3LightTheme } from "react-native-paper";
import { ITheme } from "../types";
import { colors } from "./venue-default/index";
import { styles } from "./venue-default/index";
import { headlines } from "./venue-default/index";
import { fonts } from "./venue-default/index";

const breakpoint: ITheme["breakpoint"] = {
    portraitWidth: 600,
    tabletWidth: 601,
    mediumTabletWidth: 960,
    largeTabletWidth: 1280,
};

const dimensions: ITheme["dimensions"] = {
    maxFormWidth: 600,
};

export const theme: ITheme = {
    dark: false,
    animation: {
        scale: 1.5,
    },
    styles,
    spacingScale: 10,
    borderWidth: 1,
    borderRadius: 15,
    borderRadiusTiny: 4,
    borderRadiusButton: 35,
    borderRadiusSmall: 8,
    borderRadiusLarge: 35,

    headlines,
    navigation: {
        ...DefaultTheme,
        dark: false,
        colors: {
            ...DefaultTheme.colors,
            notification: "#c00f4f",
        },
    },
    fonts,
    colors,
    breakpoint,
    dimensions,
    roundness: 8,
};
